import { Routes } from '@angular/router';
import { ParaSharedLayoutComponent } from './para-shared-layout.component';
import { ParaAuthGuard } from '@para/shared/guards/para-auth.guard';
import { PARA_SHELL_ALLOWED_ROLES } from '@para/shared/para-default-route.util';

const paraAreaRouteData = {
	progress: { roles: [...PARA_SHELL_ALLOWED_ROLES] },
};

/**
 * PARA shell route (`/progress`). Merged into the app root routes in {@link AppRoutingModule}.
 * Role-specific UI is chosen inside the lazy module (see {@link paraExperienceForRole}).
 */
export const PARA_SHELL_ROUTES: Routes = [
	{
		path: '',
		canActivate: [ParaAuthGuard],
		canActivateChild: [ParaAuthGuard],
		component: ParaSharedLayoutComponent,
		data: paraAreaRouteData.progress,
		children: [
			{
				path: 'progress',
				loadChildren: () => import('@para/progress/progress.module').then((m) => m.ParaProgressModule),
				data: paraAreaRouteData.progress,
			},
		],
	},
];
